<div class="chat-not-selected-container">
  <img src="./assets/layout/no_data.svg" alt="" style="height: 32vh">
  <p class="text-sm font-light">Non hai ancora selezionato una conversazione.
    Scegline una per iniziare a chattare.</p>
</div>
